import { FileText } from 'lucide-react';

import { Button } from '@/components/ui/button';
import { cn } from '@/lib/utils';

interface LedgerEmptyStateAction {
  label: string;
  onClick: () => void;
}

interface LedgerEmptyStateProps {
  title: string;
  description: string;
  action?: LedgerEmptyStateAction;
  className?: string;
}

/**
 * Reusable empty state component for ledger-related tables and views.
 * Follows the UX patterns defined in the ledger frontend plan.
 */
export const LedgerEmptyState = ({
  title,
  description,
  action,
  className,
}: LedgerEmptyStateProps) => {
  return (
    <div
      className={cn(
        'flex flex-col items-center justify-center py-16 px-4',
        className,
      )}
    >
      {/* Icon */}
      <div className="mb-4 flex h-12 w-12 items-center justify-center rounded-full bg-gray-100">
        <FileText className="h-6 w-6 text-gray-400" />
      </div>

      {/* Title */}
      <h3 className="text-sm font-semibold text-zinc-900 dark:text-white mb-1">
        {title}
      </h3>

      {/* Description */}
      <p className="text-sm text-zinc-500 dark:text-zinc-400 text-center max-w-sm mb-4">
        {description}
      </p>

      {/* Action button */}
      {action && (
        <Button variant="outline" onClick={action.onClick} className="mt-2">
          {action.label}
        </Button>
      )}
    </div>
  );
};
